import { render, staticRenderFns } from "./SfBottomNavigationItem.vue?vue&type=template&id=13417594"
import script from "./SfBottomNavigationItem.vue?vue&type=script&lang=js"
export * from "./SfBottomNavigationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "09d65cac"
  
)

export default component.exports